import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { TrackOrders } from "../../../../Constant";
import { TrackeOrderBox } from "./TrackeOrderBox";
import { TrackOrderList } from "./TrackOrderList";

const TrackOrder = () => {
  return (
    <Col xl="5" md="12" lg="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={TrackOrders} className="card-no-border" />
        <CardBody className="pt-0">
          <TrackeOrderBox />
          <TrackOrderList />
        </CardBody>
      </Card>
    </Col>
  );
};

export default TrackOrder;
